import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';

export default function CookieBanner({ onNavigateToImpressum }) {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Überprüfe ob Cookies bereits akzeptiert wurden
    const cookiesAccepted = localStorage.getItem('it-seevetal-cookies-accepted');
    if (!cookiesAccepted) {
      // Banner nach 1 Sekunde anzeigen (besseres UX)
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (cookiesAccepted === 'true') {
      // Wenn akzeptiert, Google Analytics laden
      loadGoogleAnalytics();
    }
  }, []);

  const loadGoogleAnalytics = () => {
    // Google Analytics Script laden
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-CJVX7L79BP';
    document.head.appendChild(script);

    // Warte bis Script geladen ist
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', 'G-CJVX7L79BP', {
        'anonymize_ip': true // IP anonymisieren (DSGVO)
      });
    };
  };

  const handleAccept = () => {
    localStorage.setItem('it-seevetal-cookies-accepted', 'true');
    setShowBanner(false);
    // Google Analytics laden
    loadGoogleAnalytics();
  };

  const handleReject = () => {
    localStorage.setItem('it-seevetal-cookies-accepted', 'false');
    setShowBanner(false);
  };

  const handleNavigateToDatenschutz = () => {
    setShowBanner(false);
    onNavigateToImpressum();
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 p-4 md:p-6 bg-black bg-opacity-20">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
        <div className="p-6 md:p-8">
          {/* Header mit Icon */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <Cookie className="w-8 h-8 text-blue-600" />
            </div>

            <div className="flex-1">
              {/* Titel */}
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2">
                Wir nutzen Cookies & Analytics
              </h3>

              {/* Beschreibung */}
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Wir verwenden <strong>Google Analytics</strong>, um deine Website-Nutzung zu verstehen und sie zu verbessern. 
                <strong> Keine persönlichen Daten</strong> werden erfasst – nur anonyme Daten für Statistiken.
              </p>

              {/* Info Box */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                <p className="text-xs md:text-sm text-gray-700 mb-3">
                  <strong className="text-blue-900">📊 Was wird erfasst:</strong> Seitenaufrufe, Besuchsdauer, Gerätetyp, Browser (anonymisiert)
                </p>
                <p className="text-xs md:text-sm text-gray-700">
                  <strong className="text-blue-900">🔒 Deine Rechte:</strong> Du kannst Cookies jederzeit{' '}
                  <button
                    onClick={handleNavigateToDatenschutz}
                    className="text-blue-600 hover:text-blue-800 underline font-medium cursor-pointer"
                  >
                    in der Datenschutzerklärung
                  </button>{' '}
                  widerrufen.
                </p>
              </div>
            </div>

            {/* Close Button */}
            <button
              onClick={handleReject}
              className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition"
              aria-label="Cookies ablehnen"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-end pt-4 border-t border-gray-200">
            <button
              onClick={handleReject}
              className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-medium text-sm md:text-base cursor-pointer"
            >
              Ablehnen
            </button>
            <button
              onClick={handleAccept}
              className="px-8 py-3 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg hover:shadow-lg transition font-medium text-sm md:text-base cursor-pointer"
            >
              ✓ Alle akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}